import { createElement } from 'src/app/core/helpers/dom';
import Tooltip from 'src/app/project/features/tooltip/Tooltip';
import { EIconPath } from '../../../../../shared/enums/icons.enum';
import { TColumn } from '../../columns/column.model';
import { GET_TABLE } from '../../table.ui.store';
import { createCellElement } from '../createCellElement';

export function createCreatedByElement(_index: number, _column: TColumn): HTMLElement {
  const table = GET_TABLE();
  const point = table.getPoints()[_index];
  const pointCreatedBy = point.header.createdBy;
  const user = table.users.find((_user) => _user.userId === pointCreatedBy?.id);

  let matchesKeyword = false;

  if (user && table.keyword) {
    matchesKeyword = user.userName.toLowerCase().indexOf(table.keyword.toLowerCase()) !== -1;
  } else if (table.keyword) {
    matchesKeyword =
      pointCreatedBy?.caption.toLowerCase().indexOf(table.keyword.toLowerCase()) !== -1;
  }

  let image: HTMLElement;

  if (pointCreatedBy) {
    image = createElement('img', {
      attrs: {
        class: user
          ? matchesKeyword
            ? 'table__avatar table__avatar--highlight'
            : 'table__avatar'
          : matchesKeyword
            ? 'table__avatar table__avatar--disabled table__avatar--highlight'
            : 'table__avatar table__avatar--disabled',
        src: user ? user.avatarPublicUrl : EIconPath.MISC_USER,
        'data-id': pointCreatedBy?.id,
      },
    });

    const nameTooltip = new Tooltip({
      title: user ? user.userName : pointCreatedBy?.caption + '(deleted)',
      mobileTooltip: false,
      childTooltip: false,
      element: image,
      trimTooltip: false,
      trimElement: image,
    });

    nameTooltip.createTooltip();
  } else {
    image = createElement('div');
  }

  return createCellElement({
    index: _column.index,
    width: `${_column.width}px`,
    child: image,
  });
}
